import React, { useEffect, useState } from "react";
// import { TfiReload } from 'react-icons/tfi';
import $ from "jquery";
import "react-datepicker/dist/react-datepicker.css";
import { dateFormatOKX, showPairNameUsdt } from '../../../core/helper/date-format';
import { Link, useNavigate } from "react-router-dom";
import '../../../pagination.css';
import '../../../assets/style.css';
import '../../../assets/styledev.css';
import AddTpSl from "./dialogs.js/AddTpSl";
import { styled } from '@mui/material/styles';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell, { tableCellClasses } from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import NavigateBeforeIcon from '@mui/icons-material/NavigateBefore';
import NavigateNextIcon from '@mui/icons-material/NavigateNext';
import AlertDialog from "./dialogs.js/CloseConfirmation";
import LoaderSpin from "../../../Component/Loader/LoaderSpin";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
  [`&.${tableCellClasses.head}`]: {
    background: 'transparent', color: 'rgb(243, 243, 243)', width: '100%'
  },
  [`&.${tableCellClasses.body}`]: {
    fontSize: 14,
  },
  padding: "10px 4px"
}));

const StyledTableRow = styled(TableRow)(({ theme }) => ({
  '&:nth-of-type(odd)': {
    background: 'transparent', color: 'rgb(243, 243, 243)'
  },
  background: 'transparent', color: 'rgb(243, 243, 243)',
  // hide last border
  'td,th': {
    border: 0,
  },
}));

export default function FuturesMyOrders(props) {
  const {
    myProfile = {},
    trades = {
      openOrders: [], stopOrders: [], orders: [], positions: [], pnl: [], fills: []
    },
    getOrderValue,
    getBaseAndTargetCurrency,
    cancelOrder,
    addTpSl,
    closePosition,
    pairsLoader,
    fromSymbolName,
    orderFetchLoading,
    ordersDataFetch,
    openOrdersDataFetch,
    positionsDataFetch,
    orderHistoryDataFetch,
    stopOrderDataFetch,
    pnlOrderDataFetch,
    fillsOrderDataFetch,
    tradesBackPage
  } = props;
  const navigate = useNavigate();
  const [userHistoryTab, setUserHistoryTab] = useState("Positions");
  useEffect(() => {
    $(".status_change .dropdown-item").click(function () {
      var getStatusText = $(this).text();
      $(this).closest(".status_dropdown").find(".status__btn").text(getStatusText);
      var generateStatusClass = `${$(this).attr('data-class')}-status`
      $(this).closest(".status_dropdown").attr("data-color", `${generateStatusClass}`);
    })
  }, []);
  // const copyText = (data = {}) => {
  //   if (data.text) {
  //     var input = document.createElement("input");
  //     document.body.appendChild(input);
  //     input.value = data.text;
  //     input.select();
  //     document.execCommand("Copy");
  //     input.remove();
  //     toast({ type: "success", message: data.message });
  //   }
  // }
  return (
    <div>

      <div className='d-flex flex-row trading-page-order-details-section '>
        <div className='col-12'>
          <div className="d-flex justify-content-start paired-trade-table-section align-items-center py-3 py-sm-3 py-md-3 py-lg-0">
            <div className="">
              <ul className="nav nav-pills" id="pills-tab" role="tablist">
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Positions")}>
                  <button
                    className="nav-link active"
                    id="pills-positions-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positions"
                    type="button" role="tab"
                    aria-controls="pills-positions"
                    aria-selected="false"
                  >
                    Positions ({trades?.positions?.list?.length})
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Open orders")}>
                  <button
                    className="nav-link"
                    id="pills-openorders-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-openorders"
                    type="button" role="tab"
                    aria-controls="pills-openorders"
                    aria-selected="false"
                  >
                    Open Order ({trades?.openOrders?.list?.length})
                  </button>
                </li>

                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Stop order")}>
                  <button
                    className="nav-link"
                    id="pills-positionhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positionhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-positionhistory"
                    aria-selected="false"
                  >
                    Stop/TP-SL Order ({trades?.stopOrders?.list?.length})
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Realized pnl")}>
                  <button
                    className="nav-link"
                    id="pills-positionhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positionhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-positionhistory"
                    aria-selected="false"
                  >
                    Realized PNL
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Fills")}>
                  <button
                    className="nav-link"
                    id="pills-positionhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-positionhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-positionhistory"
                    aria-selected="false"
                  >
                    Fills
                  </button>
                </li>
                <li className="nav-item" role="presentation" onClick={() => setUserHistoryTab("Order history")}>
                  <button
                    className="nav-link"
                    id="pills-orderhistory-tab"
                    data-bs-toggle="pill"
                    data-bs-target="#pills-orderhistory"
                    type="button"
                    role="tab"
                    aria-controls="pills-orderhistory"
                    aria-selected="false"
                  >
                    Order History
                  </button>
                </li>
              </ul>
            </div>

          </div>

          {(!myProfile && !myProfile?._id)
            ?
            <div className='trading-page-order-tabs-section pt-5'>
              <span className='trade-bottom-login-text-1'>
                <span className='fc-g cursor-pointer' onClick={() => navigate('/login')}>Login </span>(or)
                <span className='fc-g cursor-pointer' onClick={() => navigate('/register')}> Register Now</span> to trade
              </span>
            </div>
            : (pairsLoader || orderFetchLoading) ? <div className='trading-page-order-tabs-section pt-3'><LoaderSpin /></div> :
              <>
                <div className="trading-page-order-table-details-section" style={{ height: '30vh', overflow: 'auto', borderRight: '1px solid rgb(238, 240, 242)' }}>
                  {userHistoryTab == "Open orders" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 850, justifyContent: 'center' }} aria-label="customized table" stickyHeader >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Contract</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Order Price</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Filled</StyledTableCell>
                            <StyledTableCell>Order Value</StyledTableCell>
                            <StyledTableCell>Take Profit & Stop Loss</StyledTableCell>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Cancel All</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.openOrders?.list?.length > 0 && trades?.openOrders.list?.map((elem, i) => {
                            // if (elem.type !== 'limit' || elem.type !== 'market') return null;
                            const {
                              orderId = null,
                              symbol = '',
                              orderType = '',
                              price = '0',
                              qty = '0',
                              side = '',
                              leavesQty = '0',
                              stopLoss = '0',
                              createdTime = null,
                              takeProfit = '0'
                            } = elem
                            const clrClassName = side == 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            // <TpSlDetails tpTriggerPx={tpTriggerPx} slTriggerPx={slTriggerPx} tpTriggerPxType={tpTriggerPxType} tpOrdPx={tpOrdPx} slOrdPx={slOrdPx} slTriggerPxType={slTriggerPxType}
                            // />
                            return <StyledTableRow key={i}>
                              <StyledTableCell>{symbol ?
                                <Link to={"/futures/trade/" + symbol} className="text-white">{getBaseAndTargetCurrency(symbol)?.currency}</Link> : ""
                              }</StyledTableCell>
                              <StyledTableCell className={"capitalizeText " + (clrClassName)}>{`${side == 'Buy' ? 'Long' : 'Short'}/${orderType}`}</StyledTableCell>
                              <StyledTableCell>{price}</StyledTableCell>
                              <StyledTableCell>{qty}</StyledTableCell>
                              <StyledTableCell>{Number(qty) - Number(leavesQty)} {showPairNameUsdt(symbol, '-')?.split('-')?.[0]}</StyledTableCell>
                              <StyledTableCell>{getOrderValue(elem)} {showPairNameUsdt(symbol, '-')?.split('-')?.[1]}</StyledTableCell>
                              <StyledTableCell>{takeProfit || 0}<br />{stopLoss || 0}</StyledTableCell>
                              <StyledTableCell>{dateFormatOKX(createdTime)}</StyledTableCell>
                              <StyledTableCell><div className="d-flex justify-content-start"><button type="button" className="market-trade-button px-1" onClick={async () => await cancelOrder({ orderId, symbol, category: 'linear' })}>Cancel</button></div></StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.openOrders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Active Orders Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.openOrders ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => openOrdersDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.openOrders?.nextPageCursor && trades?.openOrders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => openOrdersDataFetch(trades?.openOrders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Positions" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader >
                        <TableHead>
                          <TableRow>
                            <StyledTableCell onClick={() => window.open('https://utistaking.com/', '_blank', 'noopener,noreferrer')}>Contract</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Value</StyledTableCell>
                            <StyledTableCell>Entry Price</StyledTableCell>
                            <StyledTableCell>Mark Price</StyledTableCell>
                            <StyledTableCell>Liquidation Price</StyledTableCell>
                            <StyledTableCell>Margin</StyledTableCell>
                            <StyledTableCell>PNL (ROE)</StyledTableCell>
                            {/* <StyledTableCell>Realized PNL</StyledTableCell> */}
                            <StyledTableCell>TP/SL</StyledTableCell>
                            {/* <StyledTableCell>Auto-Deposit Margin</StyledTableCell> */}
                            <StyledTableCell>Close</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.positions?.list?.length > 0 && trades?.positions?.list.map((elem, i) => {

                            const { symbol = '', leverage = 0, side = '', size = 0, positionValue = 0, avgPrice = 0, markPrice = 0, liqPrice = 0, positionIM = 0, unrealisedPnl = 0, takeProfit = '', stopLoss = '' } = elem;

                            const clrClassName = side === 'Buy' ? 'color-green-futures' : 'color-red-futures';

                            const getCurr = getBaseAndTargetCurrency(symbol);

                            const roe = Number(positionIM) > 0 ? (Number(unrealisedPnl) / Number(positionIM)) * 100 : 0;

                            return (
                              <StyledTableRow key={i}>
                                <StyledTableCell>
                                  <Link to={`/futures/trade/${symbol}`} className="text-white">
                                    {getCurr?.currency}
                                  </Link>
                                  <br />
                                  <span className="d-flex gap-1">
                                    <span>{leverage}x</span>
                                    <span className={clrClassName} style={{ fontSize: 'small' }}>
                                      {side === 'Buy' ? 'Long' : 'Short'}
                                    </span>
                                  </span>
                                </StyledTableCell>
                                <StyledTableCell className={clrClassName}>
                                  {Number(size)} {getCurr?.baseCurrency}
                                </StyledTableCell>
                                <StyledTableCell>
                                  {Number(positionValue).toFixed(2)} USDT
                                </StyledTableCell>
                                <StyledTableCell>{Number(avgPrice)}</StyledTableCell>
                                <StyledTableCell>{Number(markPrice)}</StyledTableCell>
                                <StyledTableCell>{liqPrice ? Number(liqPrice) : '--'}</StyledTableCell>
                                <StyledTableCell>{Number(positionIM).toFixed(2)} USDT</StyledTableCell>
                                <StyledTableCell>
                                  <span className={unrealisedPnl >= 0 ? 'color-green-futures' : 'color-red-futures'}>
                                    {Number(unrealisedPnl).toFixed(2)} USDT
                                  </span>
                                  <br />
                                  <span className={roe >= 0 ? 'color-green-futures' : 'color-red-futures'}>
                                    ({roe.toFixed(2)}%)
                                  </span>
                                </StyledTableCell>
                                <StyledTableCell>
                                  {takeProfit && <span className="color-green-futures">{takeProfit}</span>}
                                  {stopLoss && <><br /><span className="color-red-futures">{stopLoss}</span></>}
                                  <AddTpSl elem={elem} getBaseAndTargetCurrency={getBaseAndTargetCurrency} addTpSl={addTpSl} type={(takeProfit || stopLoss) ? "modify" : "add"} cancelOrder={cancelOrder} takeProfit={takeProfit} stopLoss={stopLoss} trades={trades} ordersDataFetch={ordersDataFetch} />
                                </StyledTableCell>
                                <StyledTableCell>
                                  <AlertDialog closePosition={closePosition} elem={elem} size={size} fromSymbolName={fromSymbolName} getCurr={getCurr} />
                                </StyledTableCell>

                              </StyledTableRow>
                            );
                          })}
                          {trades?.positions?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Active Position Found!</StyledTableCell>

                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.positions ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => positionsDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.positions?.nextPageCursor && trades?.positions?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => positionsDataFetch(trades?.positions?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Order history" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Contract</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Order Price</StyledTableCell>
                            <StyledTableCell>Filled</StyledTableCell>
                            <StyledTableCell>Unfilled</StyledTableCell>
                            <StyledTableCell>Stop Price</StyledTableCell>
                            <StyledTableCell>Fill Price</StyledTableCell>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Status</StyledTableCell>
                            {/* <StyledTableCell>Action</StyledTableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.orders?.list?.length > 0 && trades?.orders.list?.map((elem, i) => {
                            if (elem?.orderStatus === 'New' || elem?.orderStatus === 'Open' || elem?.orderStatus === 'Active') { return null }

                            const { side = '', symbol = '', qty = '0', price = '0', orderType = '0', leavesQty = '0', stopLoss = '0', triggerPrice = '0', avgPrice = '0', updatedTime = '0', orderStatus = '0' } = elem;

                            const clrClassName = (side === 'Buy' || side.includes('Close')) ? 'color-green-futures' : 'color-red-futures';
                            const getCurr = getBaseAndTargetCurrency(symbol)
                            return <StyledTableRow key={i}>
                              <StyledTableCell data-label="Symbol">{symbol ?
                                <Link to={"/futures/trade/" + symbol} className={clrClassName}>{getCurr?.currency}</Link> : ""
                              }
                              </StyledTableCell>
                              <StyledTableCell data-label="Type" className="capitalizeText">{orderType || '--'}/<span className={clrClassName}>{side || '--'}</span></StyledTableCell>
                              <StyledTableCell className={clrClassName}>{qty} {getCurr?.baseCurrency}</StyledTableCell>
                              <StyledTableCell data-label="Fill | Order price" className="capitalizeText ">{price}</StyledTableCell>
                              <StyledTableCell data-label="Filled | Total">{Number(qty) - Number(leavesQty)} {getCurr?.baseCurrency}</StyledTableCell>
                              <StyledTableCell data-label="UnFilled">{leavesQty} {getCurr?.baseCurrency}</StyledTableCell>
                              <StyledTableCell data-label="Stop">{triggerPrice || stopLoss || 0}</StyledTableCell>
                              <StyledTableCell data-label="Fill Price">{avgPrice || 0}</StyledTableCell>
                              <StyledTableCell data-label="Time">{dateFormatOKX(updatedTime)}</StyledTableCell>
                              <StyledTableCell data-label="Status" className="capitalizeText">{orderStatus}</StyledTableCell>
                              {/* <StyledTableCell data-label="Action" className="cursor-pointer" onClick={()=> handleClickOpenOrderDetails()}>CLick</StyledTableCell> */}
                            </StyledTableRow>
                          })}
                          {trades?.orders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No History Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {tradesBackPage?.orders ? <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => orderHistoryDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null}
                              {
                                (trades?.orders?.nextPageCursor && trades?.orders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => orderHistoryDataFetch(trades?.orders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Stop order" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Contract</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Trigger Price</StyledTableCell>
                            <StyledTableCell>Order Price</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Order Status</StyledTableCell>
                            <StyledTableCell>Time</StyledTableCell>
                            <StyledTableCell>Cancel All</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.stopOrders?.list?.length > 0 && trades?.stopOrders?.list.map((elem, i) => {
                            // if (elem.type !== 'limit_stop' || elem.type !== 'market_stop') return null;
                            const { tpslMode = '', symbol = '', orderType = '', price = '0', qty = '0', side = '', orderStatus = '0', triggerPrice = '0', createdTime = null, stopOrderType = '', triggerBy = '' } = elem;
                            // const getCurr = getBaseAndTargetCurrency(symbol)
                            const clrClassName = side == 'Buy' ? 'color-green-futures' : 'color-red-futures';
                            const tpSlClr = stopOrderType === 'TakeProfit' ? 'color-green-futures ' : stopOrderType === 'StopLoss' ? 'color-red-futures ' : '';
                            return <StyledTableRow key={i}>
                              <StyledTableCell data-label="Symbol">{symbol ?
                                <Link to={"/futures/trade/" + symbol} className="text-white">{getBaseAndTargetCurrency(symbol)?.currency}</Link> : ""
                              }
                              </StyledTableCell>
                              <StyledTableCell data-label="Side" className={"capitalizeText " + (clrClassName)}>{`${side == 'Buy' ? 'Long' : 'Short'}/${orderType}`}</StyledTableCell>
                              <StyledTableCell data-label="Stop Price" className={"capitalizeText " + (tpSlClr)}>{stopOrderType === 'TakeProfit' ? 'TP ' : stopOrderType === 'StopLoss' ? 'SL ' : ''}{triggerPrice}</StyledTableCell>
                              <StyledTableCell data-label="Order pricer">{price}</StyledTableCell>
                              <StyledTableCell data-label="Amount">{qty}</StyledTableCell>
                              <StyledTableCell data-label="Order Status">{orderStatus}</StyledTableCell>
                              <StyledTableCell data-label="Order time">{dateFormatOKX(createdTime)}</StyledTableCell>
                              <StyledTableCell><div className="d-flex justify-content-start"><button type="button" className="market-trade-button px-1" onClick={async () => {
                                let tradeParams = {
                                  category: 'linear',
                                  side: side,
                                  symbol: symbol,
                                  tpslMode: tpslMode || 'Full',
                                }
                                if (stopOrderType === 'TakeProfit') {
                                  tradeParams.takeProfit = '0';
                                  tradeParams.tpOrderType = orderType || 'Market'
                                  tradeParams.tpTriggerBy = triggerBy || 'MarkPrice'
                                  await addTpSl(tradeParams, 'addTpSL');
                                }
                                else if (stopOrderType === 'StopLoss') {
                                  tradeParams.stopLoss = '0';
                                  tradeParams.slOrderType = orderType || 'Market';
                                  tradeParams.slTriggerBy = triggerBy || 'MarkPrice'
                                  await addTpSl(tradeParams, 'addTpSL');
                                }

                              }}>Cancel</button></div></StyledTableCell>
                            </StyledTableRow>
                          })}
                          {trades?.stopOrders?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Stop Orders Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.stopOrders ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => stopOrderDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.stopOrders?.nextPageCursor && trades?.stopOrders?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => stopOrderDataFetch(trades?.stopOrders?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Realized pnl" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Contract</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Realized PNL</StyledTableCell>
                            <StyledTableCell>Close Time</StyledTableCell>
                            {/* <StyledTableCell>PNL Details</StyledTableCell> */}
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.pnl?.list?.length > 0 && trades?.pnl?.list.map((elem, i) => {
                            const {
                              symbol = '',
                              orderType = '',
                              closedPnl = '0',
                              updatedTime = ''
                            } = elem
                            const clrClassName = Number(closedPnl) > 0 ? 'color-green-futures' : 'color-red-futures';
                            return <StyledTableRow key={i}>
                              <StyledTableCell data-label="Symbol">{symbol ?
                                <Link to={"/futures/trade/" + symbol} className="text-white">{getBaseAndTargetCurrency(symbol)?.currency}</Link> : ""
                              }
                              </StyledTableCell>
                              <StyledTableCell data-la bel="Type" className="capitalizeText">{orderType}</StyledTableCell>
                              <StyledTableCell data-label="PnL" className={"capitalizeText " + (clrClassName)}>{closedPnl} USDT</StyledTableCell>
                              <StyledTableCell data-label="Order time">{dateFormatOKX(updatedTime)}</StyledTableCell>

                            </StyledTableRow>
                          })}
                          {trades?.pnl?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No PnL Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.pnl ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => pnlOrderDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.pnl?.nextPageCursor && trades?.pnl?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => pnlOrderDataFetch(trades?.pnl?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                  {userHistoryTab == "Fills" ?
                    <TableContainer>
                      <Table sx={{ minWidth: window.innerWidth < 700 ? 900 : 1000, justifyContent: 'center' }} aria-label="customized table" stickyHeader size='small'>
                        <TableHead>
                          <TableRow>
                            <StyledTableCell>Contract</StyledTableCell>
                            <StyledTableCell>Type</StyledTableCell>
                            <StyledTableCell>Side</StyledTableCell>
                            <StyledTableCell>Amount</StyledTableCell>
                            <StyledTableCell>Filled Value</StyledTableCell>
                            <StyledTableCell>Filled Price</StyledTableCell>
                            <StyledTableCell>Filled Qty</StyledTableCell>
                            <StyledTableCell>Filled Type</StyledTableCell>
                            <StyledTableCell>Fees</StyledTableCell>
                            <StyledTableCell>Time</StyledTableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody sx={{
                          '&.MuiTableBody-root': {
                            height: '100%',
                          }
                        }}>
                          {trades?.fills?.list?.length > 0 && trades?.fills?.list.map((elem, i) => {
                            const { side = '', symbol = '', orderQty = '0', execQty = '0', execPrice = '', orderType = '', execValue = '', execType = '', execFee = '', execTime = '', feeCurrency = '' } = elem;
                            const clrClassName = (side === 'Buy' || side.includes('Close')) ? 'color-green-futures' : 'color-red-futures';
                            const getCurr = getBaseAndTargetCurrency(symbol)
                            return <StyledTableRow key={i}>
                              <StyledTableCell data-label="Symbol">{symbol ?
                                <Link to={"/futures/trade/" + symbol} className={clrClassName}>{getBaseAndTargetCurrency(symbol)?.currency}</Link> : ""
                              }
                              </StyledTableCell>

                              <StyledTableCell className='capitalizeText'>{orderType || '--'}</StyledTableCell>
                              <StyledTableCell className={`capitalizeText ${clrClassName}`}>{side || '--'}</StyledTableCell>
                              <StyledTableCell>{orderQty} {getCurr?.baseCurrency}</StyledTableCell>
                              <StyledTableCell>{execValue || 0} {getCurr?.quoteCurrency}</StyledTableCell>
                              <StyledTableCell>{execPrice || 0}</StyledTableCell>
                              <StyledTableCell>{execQty || 0} {getCurr?.baseCurrency}</StyledTableCell>
                              <StyledTableCell>{execType || '--'}</StyledTableCell>
                              <StyledTableCell>{execFee || 0} {feeCurrency || ''}</StyledTableCell>
                              <StyledTableCell>{dateFormatOKX(execTime)}</StyledTableCell>
                              {/* <StyledTableCell data-label="Action" className="cursor-pointer" onClick={()=> handleClickOpenOrderDetails()}>CLick</StyledTableCell> */}
                            </StyledTableRow>
                          })}
                          {trades?.fills?.list?.length == 0 &&
                            <StyledTableRow>
                              <StyledTableCell className='text-white'>No Fills Found!</StyledTableCell>
                            </StyledTableRow>
                          }
                          <StyledTableRow>
                            <div className="d-flex justify-content-start align-items-center pt-3 pb-2" style={{ gap: '10px' }}>
                              {
                                tradesBackPage?.fills ?
                                  <button type="button" className="market-trade-button ps-2 pe-3" onClick={() => fillsOrderDataFetch('1')}><NavigateBeforeIcon fontSize="small" />Back To First Page</button> : null
                              }
                              {
                                (trades?.fills?.nextPageCursor && trades?.fills?.list?.length == trades.dataLimit) ? <button type="button" className="market-trade-button ps-3 pe-2" onClick={() => fillsOrderDataFetch(trades?.fills?.nextPageCursor)}>Next Page<NavigateNextIcon fontSize="small" /></button> : null
                              }
                            </div>
                          </StyledTableRow>
                        </TableBody>
                      </Table>
                    </TableContainer> : null
                  }
                </div>
              </>

          }
        </div>
      </div>

    </div>
  );
}
